export default class SettingsResponse {
  constructor(data = {}) {
    this.favoritesCount =
      data.favorites_count ?? 0;

    this.myVacanciesCount =
      data.my_vacancies_count ?? 0;

    this.friendsCount =
      data.friends_count ?? 0;

    this.requestsCount =
      data.requests_count ?? 0;

    this.isAdmin =
      data.is_admin ?? false;

    this.isEmployer =
      data.is_employer ?? false;

    this.isFirstTutorialWasSeen =
      data.is_first_tutorial_was_seen ?? false;

    this.isSecondTutorialWasSeen =
      data.is_second_tutorial_was_seen ?? false;

    this.aiPolicyAccept =
      data.ai_policy_accept ?? false;

    this.isDigitalSigned =
      data.is_digital_signed ?? false;

    this.totalFillingCount =
      data.total_filling_count ?? 0;

    this.name =
      data.name ?? "";

    this.specifics =
      data.specifics ?? "";

    this.asrConfiguration =
      data.asr_configuration ?? false;

    this.isNewResponses =
      data.is_new_responses ?? false;
  }
}